import { ref, computed } from '@vue/composition-api';

import type { Viewer } from '@/types';
import { LiceseType } from '@/types';
import { container, Tokens } from '@/di';
import type { AuthService } from '@/services';

const authService = container.get<AuthService>(Tokens.AuthService);

export const viewer = ref<Viewer | null>(null);
export const loading = ref(true);

function setViewer(value: Viewer | null) {
  viewer.value = value;
}

export async function reloadViewer(): Promise<Viewer | null> {
  try {
    loading.value = true;

    const result = await authService.me();
    setViewer(result);

    return result;
  } catch (e: unknown) {
    setViewer(null);

    return null;
  } finally {
    loading.value = false;
  }
}

export async function getViewer(): Promise<Viewer | null> {
  if (viewer.value !== null) {
    return viewer.value;
  }

  return reloadViewer();
}

export const authenticated = computed(() => {
  return viewer.value !== null;
});

export const hasSubscription = computed(() => {
  return viewer.value?.license.type === LiceseType.TEAM;
});

export default function useViewer() {
  return {
    viewer,
    authenticated,
    loading,
    hasSubscription,
    setViewer,
  };
}
